// App Imports
import areas from './arealist'
import pincodes from './list'

export default {
  pincodes,
  areas
}
